export default "__VITE_ASSET__D$gTTJC$__"